"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const crypto_1 = require("@iov/crypto");
const encoding_1 = require("@iov/encoding");
const util_1 = require("./util");
function buildCondition(extension, type, idBytes) {
    // https://github.com/iov-one/weave/blob/v0.21.0/conditions.go#L35-L38
    const out = Uint8Array.from([...encoding_1.Encoding.toAscii(`${extension}/${type}/`), ...idBytes]);
    return out;
}
function buildSwapCondition(swap) {
    // https://github.com/iov-one/weave/blob/v0.15.0/x/aswap/handler.go#L287
    const weaveSwapId = new Uint8Array([...swap.id.data, "|".charCodeAt(0), ...swap.hash]);
    return buildCondition("aswap", "pre_hash", weaveSwapId);
}
function buildMultisignatureCondition(id) {
    return buildCondition("multisig", "usage", encoding_1.Uint64.fromNumber(id).toBytesBigEndian());
}
exports.buildMultisignatureCondition = buildMultisignatureCondition;
function buildEscrowCondition(id) {
    // https://github.com/iov-one/weave/blob/v0.21.0/x/escrow/model.go#L83-L87
    return buildCondition("escrow", "seq", encoding_1.Uint64.fromNumber(id).toBytesBigEndian());
}
exports.buildEscrowCondition = buildEscrowCondition;
function buildElectionRuleCondition(id) {
    return buildCondition("gov", "rule", encoding_1.Uint64.fromNumber(id).toBytesBigEndian());
}
function conditionToWeaveAddress(cond) {
    return new crypto_1.Sha256(cond).digest().slice(0, 20);
}
exports.conditionToWeaveAddress = conditionToWeaveAddress;
function conditionToAddress(chainId, cond) {
    const prefix = util_1.addressPrefix(chainId);
    const bytes = conditionToWeaveAddress(cond);
    return util_1.encodeBnsAddress(prefix, bytes);
}
exports.conditionToAddress = conditionToAddress;
function swapToAddress(chainId, swap) {
    return conditionToAddress(chainId, buildSwapCondition(swap));
}
exports.swapToAddress = swapToAddress;
function multisignatureIdToAddress(chainId, multisignatureId) {
    // TODO: remove this intermediate step in https://github.com/iov-one/iov-core/issues/1231
    const numericId = encoding_1.Uint64.fromBytesBigEndian(multisignatureId).toNumber();
    return conditionToAddress(chainId, buildMultisignatureCondition(numericId));
}
exports.multisignatureIdToAddress = multisignatureIdToAddress;
function escrowIdToAddress(chainId, escrowId) {
    // TODO: remove this intermediate step in https://github.com/iov-one/iov-core/issues/1231
    const numericId = encoding_1.Uint64.fromBytesBigEndian(escrowId).toNumber();
    return conditionToAddress(chainId, buildEscrowCondition(numericId));
}
exports.escrowIdToAddress = escrowIdToAddress;
function electionRuleIdToAddress(chainId, electionRule) {
    return conditionToAddress(chainId, buildElectionRuleCondition(electionRule));
}
exports.electionRuleIdToAddress = electionRuleIdToAddress;
//# sourceMappingURL=conditions.js.map